/** Formatação numérica do painel de validação Rent_Bud (reutilizável em testes). */

export function fmtIntSpaced(value) {
  const n = Math.round(Number(value));
  const sign = n < 0 ? '-' : '';
  const intStr = Math.abs(n).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
  return `${sign}${intStr}`;
}

export function fmtEur(value) {
  if (value === null || value === undefined || Number.isNaN(Number(value))) return '—';
  return `${fmtIntSpaced(value)} €`;
}

export function fmtPct(value, digits = 2) {
  if (value === null || value === undefined || Number.isNaN(value)) return '—';
  return `${(Number(value) * 100).toFixed(digits)} %`;
}

/**
 * Número com milhares separados por espaço e até ``digits`` casas decimais,
 * sem zeros à direita. Usado nas fórmulas dos "Cálculos auxiliares", onde
 * arredondar ao euro esconderia os operandos (ex.: 7,891875 €/peça).
 */
export function fmtNum(value, digits = 6) {
  if (value === null || value === undefined || Number.isNaN(Number(value))) return '—';
  const [rawInt, rawDec = ''] = Number(value).toFixed(digits).split('.');
  const sign = rawInt.startsWith('-') ? '-' : '';
  const int = rawInt.replace('-', '').replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
  const dec = rawDec.replace(/0+$/, '');
  return `${sign}${int}${dec ? `,${dec}` : ''}`;
}

/** Euros com 2 casas decimais — precisão de auditoria (vs. ``fmtEur``). */
export function fmtEurExact(value) {
  if (value === null || value === undefined || Number.isNaN(Number(value))) return '—';
  return `${fmtNum(value, 2)} €`;
}
